var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "24px",
    viewBox: "0 0 14 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.71684797,18.9291837 C6.25120507,18.9072464 5.79167436,18.7139316 5.43673897,18.3499257 L-4.38759137,8.27452973 C-5.14317742,7.49963431 -5.14444526,6.24458085 -4.39052936,5.47139825 L-4.54158275,5.62631188 C-3.7876193,4.85308053 -2.56208698,4.85627621 -1.80830161,5.62932494 L6.94440482,14.6057111 L15.8283782,5.80731324 C16.5970359,5.04605963 17.8206509,5.06666329 18.5612943,5.85322203 L18.4129002,5.69562837 C19.1535903,6.48223671 19.1290862,7.73884091 18.3622603,8.49828035 L8.36796804,18.3963019 C7.9123356,18.8475454 7.29684539,19.0240686 6.71684797,18.9291837 Z",
    id: "arrow-left-path"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#arrow-left-path"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#4BD4B0",
    fillRule: "nonzero",
    transform: "translate(7.000000, 12.000000) rotate(-270.000000) translate(-7.000000, -12.000000) ",
    xlinkHref: "#arrow-left-path"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/Arrow-Left.1e7b5cae9e05b19a5dfb1333ffacbf2d.svg";
export { ForwardRef as ReactComponent };